module.exports = __webpack_public_path__ + "img/wallet.84887843.svg";